/* eslint-disable react/jsx-filename-extension */
import React from "react";
import { Route, Routes } from "react-router-dom";
import HomeLayout from "../layouts/home/index";
import Home from "../layouts/home/overview";
import Payouts from "../layouts/home/payout";
import Settings from "../layouts/home/settings";
import Stores from "../layouts/home/stores";
import LoginPage from "../layouts/login";
import Logout from "../layouts/logout";
import NotFound from "../layouts/notFound";
import Register from "../layouts/register";

export default function RoutesPage() {
  return (
    <Routes>
      <Route path="/logout" element={<Logout />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<Register />} />
      <Route path="/" element={<HomeLayout />}>
        <Route path="" element={<Home />} />
        <Route path="settings" element={<Settings />} />
        <Route path="stores" element={<Stores />} />
        <Route path="payouts" element={<Payouts />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
